import { render, staticRenderFns } from "./CandidateView.vue?vue&type=template&id=601b45bb&scoped=true&"
import script from "./CandidateView.vue?vue&type=script&lang=js&"
export * from "./CandidateView.vue?vue&type=script&lang=js&"
import style0 from "./CandidateView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CandidateView.vue?vue&type=style&index=1&id=601b45bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b45bb",
  null
  
)

export default component.exports